export default "__VITE_ASSET__DKwZ3ISP__"